import { createFileRoute, Link } from "@tanstack/react-router";
import { EmptyState } from "@/components/ui";
import { useApp } from "@/context/AppContext";
import { KundenKampagnen } from "@/pages/client/KundenKampagnen";

/**
 * EINE Adresse, zwei Sichten (Muster wie /studio): Kunden und die
 * Kunden-Vorschau sehen den Kampagnen-Teaser mit dem Interesse-Knopf; das
 * Team sieht ehrlich, dass der Team-Bereich noch nicht gebaut ist (Issue
 * #139) — kein Menüpunkt beim Team, die Adresse ist nur per Vorschau relevant.
 */
export const Route = createFileRoute("/_angemeldet/kampagnen")({
	component: KampagnenSeite,
});

function KampagnenSeite() {
	const { role } = useApp();
	if (role !== "mitarbeiter") return <KundenKampagnen />;
	return (
		<div className="max-w-narrow mx-auto py-10">
			<EmptyState
				icon="rocket"
				title="Kampagnen gibt es für Kunden erst als Vorstellung"
				hint="Kunden sehen den Teaser und melden Interesse; der Team-Bereich für Anzeigen und E-Mail-Kampagnen ist noch nicht gebaut (Issue #139). Über das Auge in der Kundenliste siehst du die Kundensicht."
				action={
					<Link to="/kunden" className="btn-secondary">
						Zur Kundenliste
					</Link>
				}
			/>
		</div>
	);
}
